<template>
  <div class="content-top-padding padding-for-footer bg-img" v-cloak>
    <div class="container-fluid p-0 mt-1 mb-5 d-flex justify-content-center">
      <img
        class="img-fluid d-none d-md-block"
        src="@/assets/chairman/ed-c.jpg"
        v-if="$i18n.locale == 'zh'"
      />
      <img class="img-fluid d-none d-md-block" src="@/assets/chairman/ed.jpg" v-else />
      <img
        class="img-fluid d-block d-md-none"
        src="@/assets/chairman/m_ed-c.jpg"
        v-if="$i18n.locale == 'zh'"
      />
      <img class="img-fluid d-block d-md-none" src="@/assets/chairman/m_ed-e.jpg" v-else />
    </div>

    <div class="container">
      <div class="row custom-breadcrumb main-theme mb-5 pl-3">
        <div class="d-inline-flex">
          <div>
            <router-link :to="{ name: 'Landing' }">
              {{ $t("title.home") }}
            </router-link>
          </div>
          <div class="mx-2">></div>
        </div>
        <div class="d-inline-flex">
          <div>
            <router-link :to="{ name: 'Chairman' }">
              {{ $t("title.ChairmanMsg&ED") }}
            </router-link>
          </div>
          <div class="mx-2">></div>
        </div>
        <div class="d-inline-flex">
          <div>{{ $t("title.ED") }}</div>
        </div>
      </div>

       <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Chairman' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Chairman' }" class="">
            {{ $t("title.ChairmanMsg") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'BoardMembers' }" class="">
            {{ $t("title.bms") }}
          </router-link>
          <router-link :to="{ name: 'BoardMembers' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>

      <div class="row content d-flex flex-column mb-5">
        <div class="col title">
          <h3 class="main-theme mb-5 text-uppercase font-weight-bold">
            {{ $t("title.ED") }}
          </h3>
        </div>
        <div class="col text-theme text-justify" v-html="$t('text.ED')"></div>
      </div>

      <div
        class="
          row
          routing
          d-flex
          justify-content-between
          align-items-center
          mb-5
        "
      >
        <div class="col main-theme d-flex flex-row align-items-center">
          <router-link :to="{ name: 'Chairman' }" class="">
            <img class="mr-2 route-arrow" src="@/assets/01/btn_catalog_arrow_l.svg" />
          </router-link>
          <router-link :to="{ name: 'Chairman' }" class="">
            {{ $t("title.ChairmanMsg") }}
          </router-link>
        </div>
        <div class="col main-theme d-flex justify-content-end text-right align-items-center">
          <router-link :to="{ name: 'BoardMembers' }" class="">
            {{ $t("title.bms") }}
          </router-link>
          <router-link :to="{ name: 'BoardMembers' }" class="">
            <img class="ml-2 route-arrow" src="@/assets/01/btn_catalog_arrow_r.svg" />
          </router-link>
        </div>
      </div>
    </div>
    <BackToTopBtn />
  </div>
</template>

<script>
import BackToTopBtn from "@/components/BackToTopBtn.vue";

export default {
  components: {
    BackToTopBtn,
  },
  metaInfo: {
    title: "Executive Director's Statement",
    titleTemplate: "%s - HKTB Annual Report 2020/21",
  },
};
</script>

<style lang="scss" scoped>
.bg-img {
  background-image: url(../assets/boardmembers/bg_pattern.jpg);
  background-size: cover;
}
@media (max-width: 450px) {
  .title {
    h3 {
      font-size: 6vw;
    }
  }
}
</style>
